module.exports = __webpack_public_path__ + "img/oog_oh.52680593.png";